import { getBusinessObject } from "bpmn-js/lib/util/ModelUtil";
import { escapeHTML } from "bpmn-js-properties-panel/lib/Utils";
import $ from "jquery";
import React from "react";
import { createRoot } from "react-dom/client";

import ModelerModalFormsPreview from "./modeler-modal-forms-preview";
import { language } from "../../../../../language";

window.jQuery = $;
window.$ = $;

// eslint-disable-next-line no-unused-vars
const modelProperties = ["id", "value", "smart"];

function ShowFormsPreviewModal(elementdom, itens) {
  const root = createRoot(elementdom);
  root.render(<ModelerModalFormsPreview forms={itens} />, elementdom);
}
export default function (element, bpmnFactory, options, translate, modeling) {
  const id = options.id,
    label = language.formsPreview, //options.label,
    businessObject = getBusinessObject(element);

  return {
    id,
    html:
      '<button id="cam-extensionElements-' +
      escapeHTML(id) +
      '"' +
      'data-action="openPreviewForms" ' +
      'name="selectedExtensionElement" ' +
      'class="btn info"' +
      'style="margin-left: auto;margin-right: auto;width: 100%;"' +
      '" >' +
      label +
      "</button>",
    openPreviewForms(element, node) {
      const formComponents = [];
      const extensionElements = businessObject.get("extensionElements");
      if (extensionElements) {
        const formdata = extensionElements.values.find(function (elem) {
          if (elem.$type === "camunda:FormData") {
            return true;
          }
          return false;
        });

        if (formdata && formdata.fields) {
          for (
            let idxfield = 0;
            idxfield < formdata.fields.length;
            idxfield++
          ) {
            const fieldProperties = formdata.fields[idxfield].properties
              ? formdata.fields[idxfield].properties.values
              : [];

            fieldProperties.forEach(() => {
              if (fieldProperties[0].id === "component") {
                const fielddata = fieldProperties[0].value
                  .replace(/&#34;/g, '"')
                  .replace(/&#39;/g, "'")
                  .replace(/&#38;/g, "&");

                formComponents.push(JSON.parse(fielddata));
              }
            });
          }
        }
      }

      //BuildFormListModal();
      const modelerModalFormsPreview = document.createElement(
        "modelerFormsPreview",
      );

      ShowFormsPreviewModal(modelerModalFormsPreview, formComponents);
    },
  };
}
